import { combineReducers } from "redux";
import aboutusdetails from "../features/admin/aboutus/aboutusdetails/Slice";
import ourstory from "../features/admin/aboutus/ourstory/Slice";
import whychooseus from "../features/admin/aboutus/whychooseus/Slice";
import platformwork from "../features/admin/aboutus/platformwork/Slice";
import ouruserssays from "../features/admin/aboutus/ouruserssays/Slice";
import privacypolicy from "../features/admin/aboutus/privacypolicy/Slice";
import termscondition from "../features/admin/aboutus/termscondition/Slice";
import sociallink from "../features/admin/aboutus/sociallink/Slice";

const aboutus = combineReducers({
  aboutusdetails: aboutusdetails,
  ourstory: ourstory,
  whychooseus: whychooseus,
  platformwork: platformwork,
  ouruserssays: ouruserssays,
  privacypolicy: privacypolicy,
  termscondition: termscondition,
  sociallink: sociallink,
});

export default aboutus;
